import { render } from "./InvoiceSelector.vue?vue&type=template&id=252b320c&scoped=true"
import script from "./InvoiceSelector.vue?vue&type=script&lang=js"
export * from "./InvoiceSelector.vue?vue&type=script&lang=js"

import "./InvoiceSelector.vue?vue&type=style&index=0&id=252b320c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252b320c"]])

export default __exports__